import React from 'react';

class Functions extends React.Component {
	static isPc = () => {
		const userAgent = navigator.userAgent;

		return (
			userAgent.indexOf('iPhone') < 0 &&
			userAgent.indexOf('iPad') < 0 &&
			userAgent.indexOf('iPod') < 0 &&
			userAgent.indexOf('Android') < 0
		)
	}
}

export default Functions



// WEBPACK FOOTER //
// src/common/Functions.js